<template>
    <div>
      <b-form-select v-model="selected" :options="options" class="mb-3" />
    </div>
</template>

<script>
  export default {
    name: 'List',
    props: {
      values: {
        default: () => []
      },
      labels: {
        default: () => []
      },
      value: {
        default: null
      }
    },
    computed: {
      options () {
        return this.values.map((v, i) => {
          return {
            value: v,
            text: this.labels[i]
          }
        })
      }
    },
    mounted () {
      if (!this.selected && this.values.length) {
        this.selected = this.values[0]
      }
    },
    data () {
      return {
        selected: null
      }
    },
    watch: {
      selected (val) {
        this.$emit('input', val)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/map/task_input/List.vue